import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase, Sorting, SortDirection } from 'app/shared/lib/essette-site';
import * as CD from 'app/cd/models/essette-api';
import { bindable } from 'aurelia-typed-observable-plugin';
import { MemberService, MemberType } from 'app/cd/services/member-service';
import { apiCall } from 'app/shared/lib/api/api';
import { EssPagerCustomElement } from 'app/shared/elements/ess-pager';
import { SortChangeEvent } from 'app/shared/attributes/sortable-attribute';
import { IQueryLoadOptions } from 'app/shared/lib/api/api-types';

@autoinject()
export class MemberPlanInformation extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    public memberId: string | null = null;

    @bindable.string({ defaultBindingMode: bindingMode.toView })
    protected memberType: MemberType = MemberType.Member;

    protected member: CD.Member | null = null;
    protected memberPlans: ReadonlyArray<CD.MemberPlan> = [];

    private sorting: Sorting = new Sorting();
    protected resultCount: number = 0;
    protected pageSize: number = 25;

    ////****************** Element References ***************************************////
    protected $pager!: EssPagerCustomElement;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(private readonly memberService: MemberService,
        ...rest: any[]) {
        super(...rest);
    }

    ////****************** Events ***************************************************////
    protected async reload(): Promise<void> {
        await this.loadMemberPlans();
    }

    /** Handles the grid's sort event */
    protected applySort(event: SortChangeEvent): void {
        const { property, direction } = event.detail;
        const { sorting } = this;
        if(direction === null) {
            sorting.remove(property);
        } else {
            sorting.add({
                reference: property,
                direction: direction === 'asc' ? SortDirection.Ascending : SortDirection.Descending
            });
        }
        this.reload();
        //Call stop Propagation to prevent parent table from reload and losing sort
        event.stopPropagation();
    }

    ////****************** Functions ************************************************////

    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadMemberPlans(): Promise<void> {
        if(!this.memberId) return;

        const includes: string[] = [
            'healthPlan',
            'lineOfBusiness'
        ];

        const fields: string[] = [
            'eligibility.rank',
            'healthPlan.description',
            'identifier.primary',
            'lineOfBusiness.description'
        ];

        const options: Partial<IQueryLoadOptions> = {
            includeInactive: false,
            sorting: this.sorting,
            page: this.$pager?.page || 0,
            top: this.pageSize
        };

        try {
            this.state.beginLoad();

            const response = this.memberType === MemberType.Patient ? await this.memberService.loadPlansByPatient(this.memberId, options, includes, fields) : await this.memberService.loadPlansByMember(this.memberId, options, includes, fields);
            this.memberPlans = response.results;
            this.resultCount = response.count || 0;
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
